const META_FR = {
  '/fr': {
    title: "Page d'accueil Site du Groupe iliad",
    description: "Page d'accueil Site du Groupe iliad",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/media/communiques-de-presse': {
    title: 'Groupe iliad - Communiqués de presse',
    description: 'Communiqués de presse du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/media/mediatheque': {
    title: 'Groupe iliad - Médiathèque',
    description: 'Médiathèque du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/media/mediatheque/freebox': {
    title: 'iliad Group - ',
    description: 'Médiathèque du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/action': {
    title: 'Groupe iliad - Action iliad',
    description: "Informations relatives au cours de bourses de l'action iliad",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/assemblee-generale': {
    title: 'Groupe iliad - Assembée Générale',
    description: 'Agenda et informations relatives aux assemblée générales du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/documents-legaux': {
    title: 'Groupe iliad - Documents légaux',
    description: 'Documents légaux des investisseurs du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/contact-et-agenda': {
    title: 'Groupe iliad -  Contact et agenda',
    description: 'Contact et agenda financiers du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/communiques-de-presse-financiers': {
    title: 'Groupe iliad - Communiqués de presse financiers',
    description: 'Communiqués de presse financiers du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/dette': {
    title: 'Groupe iliad - Dette',
    description: 'Informations relatives à la dette du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/information-reglementee': {
    title: 'Groupe iliad - Information réglementée',
    description: 'Informations relatives aux information réglementée du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/resultats': {
    title: 'Groupe iliad - Résultats financiers',
    description: 'Résultats financiers du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/groupe/structure-du-groupe': {
    title: 'Groupe iliad - Structure du groupe',
    description: 'Structure du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/holding/resultats': {
    title: 'iliad Holding - Résultats financiers',
    description: 'Résultats financiers iliad Holding',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/holding/communiques-de-presse-financiers': {
    title: 'iliad Holding - Communiqués de presse',
    description: 'Communiqués de presse iliad Holding',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/la-revolution-iliad': {
    title: 'Groupe iliad - La révolution iliad',
    description:
      'La révolution iliad - Entrepreneur autodidacte, Xavier Niel exerce dans l’industrie des télécoms dès la fin des années 80. Il a immédiatement une vision très claire de ce que sera Internet et l’intuition que la révolution numérique va changer le monde. C’est cette intuition qui est à l’origine de l’épopée Free.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/ethique-et-conformite': {
    title: 'Groupe iliad - Ethiques et conformité',
    description:
      'Ethiques et conformité - Qu’il s’agisse de droit des affaires, de droit des citoyens ou de relations avec nos fournisseurs, nous sommes engagés dans un processus d’amélioration continue de nos standards de conformité. Un responsable Éthique & Conformité pilote l’ensemble des actions du Groupe en ce sens.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/20-ans-innovation': {
    title: "Groupe iliad - 20ans d'innovation",
    description:
      "20ans d'innovation - Depuis 1999, iliad mène une formidable aventure entrepreneuriale, en misant sur l’innovation technologique pour libérer les usages. En 20 ans, nous avons bien grandi, mais nous avons gardé cet état d’esprit inimitable qui nous a toujours poussés à faire les choses à notre manière : l’esprit Free.",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/devise': {
    title: 'Groupe iliad - Devise',
    description:
      'Devise - Nous sommes un Groupe européen, né en France. Notre tempérament révolutionnaire vient sûrement de là… Un tempérament que résume bien notre devise : liberté, vérité, simplicité.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/gouvernance': {
    title: 'Groupe iliad - Gouvernance',
    description: 'Informations liés à la gouvernance du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/le-groupe/qui-sommes-nous': {
    title: 'Groupe iliad - Qui sommes nous',
    description: 'Chiffres clés et activité du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/vision': {
    title: 'Groupe iliad - Vision',
    description:
      'Vision - À l’origine d’iliad, il y a une ambition puissante : proposer à chacun, sur tout le territoire, un accès égal aux mêmes offres. Que vous habitiez une métropole ou un village reculé, vous paierez toujours le même prix. Cette vision nous a conduit à investir massivement, dès le début, dans le déploiement de nos propres équipements et infrastructures. Ce faisant, nous contribuons à la réduction de la fracture numérique, à la compétitivité des économies locales et à la cohésion nationale.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/presence-en-france': {
    title: 'Groupe iliad - Présence en France',
    description:
      'Présence en France - En France, nous sommes présents sur tout le territoire métropolitain et outre-mer. Découvrez l’étendue de notre présence dans chaque région via la carte ci-dessous. Sont également disponibles sur Free.fr la carte de notre couverture 5G et la carte de notre réseau Fibre optique.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/antennes-relais': {
    title: "Groupe iliad - Installation d'une antenne",
    description:
      "Installation d'une antenne - Chaque jour, Free Mobile étend la couverture de son réseau de télécommunications et en augmente progressivement la portée pour contribuer à l’amélioration du service rendu à ses abonnés. En tant que propriétaire, soyez rémunéré en contribuant vous aussi à ce développement.",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/borne-free': {
    title: "Groupe iliad - Installation d'une borne Free",
    description:
      "Installation d'une borne Free - Proposez un service supplémentaire à vos clients Free et soyez rémunéré ! En tant que propriétaire de commerce, en accueillant une borne Free dans votre établissement, vous offrez à vos clients un service de plus lié à leur mobile ou leur Freebox, tout en étant proche de chez eux. Soyez récompensé en participant à cette solution de proximité !",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/chiffres-cles': {
    title: 'Groupe iliad - Chiffres clés',
    description:
      'Chiffres clés - Plus de 15 milliards d’euros ont été investis par notre Groupe dans l’aménagement des territoires au cours de la dernière décennie. Cette politique nous permet de déployer à un rythme accéléré nos propres réseaux en France et en Italie. La preuve en chiffres.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-reseaux/temoignages': {
    title: 'Groupe iliad - Témoignages',
    description:
      'Découvrez « Le réseau mobile & nous », une série de témoignages qui montrent l’importance des relations de confiance et de proximité que Free Mobile établit au quotidien avec les acteurs de nos territoires.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-engagements/faire-les-choses-bien': {
    title: 'Groupe iliad - Faire les choses bien',
    description:
      'Faire les choses bien- Pour iliad, assumer sa responsabilité sociétale, c’est tout simplement faire les choses bien. C’est notre manière de répondre aux défis environnementaux et aux exigences légitimes de la société, comme nous répondons chaque jour aux attentes de nos abonnés.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/publications': {
    title: 'Groupe iliad - Publications',
    description: 'Publications du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-engagements/pour-nos-collaborateurs': {
    title: 'Groupe iliad - Pour nos collaborateurs',
    description:
      'Pour nos collaborateurs - iliad aujourd’hui, ce sont environ 14 000 collaborateurs qui exercent une grande variété de métiers. Des techniciens réseaux aux conseillers dédiés à la relation Abonnés en boutique ou en centre de contact, en passant par les équipes de R&D et les fonctions support, nous nous engageons à œuvrer pour l’épanouissement de chacun.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-engagements/pour-l-environnement': {
    title: "Groupe iliad - Pour l'environnement",
    description:
      "Pour l'environnement - Les télécoms ont un impact sur l’environnement, notamment en termes de consommation énergétique. Chez iliad, cela fait déjà près de 10 ans que nous agissons pour réduire l’empreinte de nos activités sur le climat et sur l’environnement. Aujourd’hui, nous allons encore plus loin.",
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-engagements/pour-la-societe': {
    title: 'Groupe iliad - Pour la société',
    description:
      'Pour la société - Depuis toujours, nous défendons les droits du consommateur, qu’il s’agisse du juste prix de sa facture télécoms ou de la protection de ses données personnelles. Cette approche a inscrit d’emblée l’activité de notre Groupe dans un projet sociétal militant, relayé depuis 2006 par la Fondation Free.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/nos-engagements/documents-esg': {
    title: 'Groupe iliad - Documents ESG',
    description: 'Déclaration de Performance Extra-Financière',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/carrieres/nos-valeurs': {
    title: 'Groupe iliad - Nos valeurs',
    description:
      'Nos valeurs - Les collaborateurs du Groupe partagent tous un état d’esprit bien particulier. Cet esprit Free, nous avons cherché à le définir en nous appuyant sur le ressenti des équipes. A l’issue d’un atelier RH, quatre valeurs ont fait l’unanimité pour expliquer ce que nous sommes.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/carrieres/metiers': {
    title: 'Groupe iliad - Métiers',
    description:
      'Métiers - Technicien Télécom, Ingénieur Radio, Conseiller Multimédia, Manager Boutique… Découvrez la diversité de nos métiers et postulez pour rejoindre la Free Family !',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/carrieres/pourquoi-nous-rejoindre': {
    title: 'Groupe iliad - Pourquoi nous rejoindre',
    description:
      'Pourquoi nous rejoindre - Un Groupe en croissance, animé par une vision entrepreneuriale forte, c’est un Groupe qui fait grandir ses collaborateurs. Rejoindre iliad, c’est la promesse de travailler sur des projets dont vous serez fiers et d’évoluer en compétences comme en responsabilités.',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/donnees-personnelles': {
    title: 'Groupe iliad - Données personnelles',
    description: 'Données personnelles - Politique de confidentialité et gestion des données personnelles',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/mentions-legales': {
    title: 'Groupe iliad - Mentions légales',
    description: 'Mentions légales du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/qualite-de-service': {
    title: 'Groupe iliad - Indicateurs de qualité de service',
    description: 'Informations liées aux indicateurs de qualité de service du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/documentation': {
    title: 'Groupe iliad - Documentation',
    description: 'Documentation du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/contact': {
    title: 'Groupe iliad - Contact',
    description: 'Page de contact',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/actualites/article': {
    title: 'Groupe iliad - Article',
    description: 'Article du Groupe iliad',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/actualites': {
    title: 'Groupe iliad - Actualités',
    description: "Retrouvez l'actualités du Groupe iliad",
    image: '/free-iliad-icon.jpg'
  },
  default: {
    title: 'Groupe iliad',
    description: 'Groupe iliad',
    image: '/free-iliad-icon.jpg'
  }
}

const META_EN = {
  '/en': {
    title: 'Homepage of iliad Group Website',
    description: 'Homepage of iliad Group Website.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/media/communiques-de-presse': {
    title: 'iliad Group - News realeases',
    description: 'iliad Group News releases.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/media/mediatheque': {
    title: 'iliad Group - Media library',
    description: 'iliad Group Media library.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/action': {
    title: 'iliad Group - Share information',
    description: 'iliad Group Share information.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/assemblee-generale': {
    title: 'iliad Group - Annual General Meeting',
    description: 'Calendar and information related to Annual General Meeting.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/contact-et-agenda': {
    title: 'iliad Group - Contact and calendar',
    description: 'Financial contact and calendar.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/communiques-de-presse-financiers': {
    title: 'iliad Group - Financial news releases',
    description: 'iliad Group Financial news releases.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/dette': {
    title: 'iliad Group - Debt',
    description: 'Information related to iliad Group debt.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/information-reglementee': {
    title: 'iliad Group - Regulatory disclosures',
    description: 'Information related to Regulatory disclosures of the iliad Group.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/resultats': {
    title: 'iliad Group - Financial results',
    description: 'iliad Group Financial results.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/investisseurs/groupe/structure-du-groupe': {
    title: 'iliad Group - Group strusture',
    description: 'iliad Group structure',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/holding/resultats': {
    title: 'iliad Holding- Financial results',
    description: 'Financial results iliad Holding',
    image: '/free-iliad-icon.jpg'
  },
  '/fr/investisseurs/holding/communiques-de-presse-financiers': {
    title: 'iliad Holding- Financial news releases',
    description: 'Financial news releases iliad Holding',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/la-revolution-iliad': {
    title: 'iliad Group - The iliad revolution',
    description:
      'The iliad revolution - A self-taught entrepreneur, Xavier Niel has worked in the telecoms industry since the late 1980s. He immediately had a very clear vision of what the Internet would represent and intuitively knew that the digital revolution was going to literally change the world. And it was thanks to this intuition that Free’s epic story began.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/ethique-et-conformite': {
    title:
      'iliad Group - Ethics and compliance - We’re fully committed to acting with the utmost integrity in everything we do, whether in our business activities or our relations with suppliers or society in general. That’s why we have a continuous improvement process in place for our compliance standards and have appointed a Chief Ethics & Compliance Officer who oversees all of the Group’s actions and initiatives in these areas.',
    description: 'Ethics and compliance',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/20-ans-innovation': {
    title: 'iliad Group - 20 years of innovation',
    description:
      '20 years of innovation - Since 1999, iliad has been living an amazing entrepreneurial adventure, pursuing technological innovation to free up different types of usages. We’ve grown a lot in the last 20 years, but we’ve never lost our unique Free spirit that has always driven us to do things our own way.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/devise': {
    title: 'iliad Group - Our motto',
    description:
      'Our motto - We’re a European group born in France. And that’s undoubtedly where our revolutionary approach comes from. An approach that’s embodied in our motto: liberty, honesty, simplicity.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/gouvernance': {
    title: 'iliad Group - Governance',
    description: 'Information related to iliad Group Governance',
    image: '/free-iliad-icon.jpg'
  },
  '/en/le-groupe/qui-sommes-nous': {
    title: 'iliad Group - Who we are',
    description: 'iliad Group key figures and activities',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/vision': {
    title: 'iliad Group - Our vision',
    description:
      'Our vision - At iliad we have always had one overriding ambition: to offer everyone, everywhere, equal access to the same offerings. Whether you live in a major city or a remote village, you’ll always pay the same price. This vision led us to invest heavily, from the very outset, in deploying our own equipment and infrastructure. In doing so, we’re helping to narrow the digital divide, boost regional economies and create national cohesion.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/presence-en-france': {
    title: 'iliad Group - Our presence in France',
    description:
      'Our presence in France - We have an operating presence across the whole of mainland France as well as in France’s overseas territories. The map below shows our presence in each region. You can also find maps of our 5G coverage and our Fiber network on Free.fr.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/antennes-relais': {
    title: 'iliad Group - Antenna installation',
    description:
      'Every day, Free Mobile is extending the coverage of its mobile telecommunications network and is gradually increasing its transmission range to give the best possible mobile service. As a real estate owner you could realize the value of your property while contributing to this development of the digital future.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/borne-free': {
    title: 'Groupe iliad - Free Kiosk installation',
    description:
      'Offer your Free customers an extra service and get paid for it! As a business owner, by hosting a Free kiosk in your establishment, you offer your customers an additional service linked to their mobile or Freebox, while being close to home. Be rewarded by participating in this local solution!',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/chiffres-cles': {
    title: 'iliad Group - Key figures',
    description:
      'Key figures - Our Group has invested over €15 billion in regional digital development over the past decade, and it’s that strategy which has allowed us to rapidly roll out our own networks in France and Italy. The figures speak for themselves.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-reseaux/temoignages': {
    title: 'iliad Group - Testimonials',
    description:
      'Watch “Making Mobile Happen” - a series of stories that show the importance of the close, trusted relations that Free Mobile builds up every day with France’s regional players.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-engagements/faire-les-choses-bien': {
    title: 'iliad Group - Doing things right',
    description:
      'Doing things right - For iliad, being a good corporate citizen basically means doing things right. It’s our way of meeting the environmental challenges and legitimate demands of today’s society, in the same way as we meet the needs and expectations of our subscribers every day in our business.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/publications': {
    title: 'iliad Group - Publications',
    description: 'iliad Group Publications',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-engagements/pour-nos-collaborateurs': {
    title: 'iliad Group - For our people',
    description:
      'For our people - iliad currently has some 14,000 employees. The jobs they do are very varied, ranging from network technicians to subscriber relations advisors working in our stores and contact centers, and not forgetting our R&D teams and support functions. Our priority is to make sure that each and every one of our people is happy in their job.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-engagements/pour-l-environnement': {
    title: 'iliad Group - For the environment',
    description:
      'For the environment - Telecoms have an environmental impact, especially when it comes to energy consumption. At iliad, we’ve been taking action to reduce the impact of our business on the climate and the environment for nearly ten years now. And today, we intend to go even further.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-engagements/pour-la-societe': {
    title: 'iliad Group - For society',
    description:
      'For society - At iliad, we’ve always stood up for consumer rights, whether about fair prices for phone bills or protecting personal data. This approach immediately positioned us as campaigners for social justice, a role that was taken up by the Free Foundation in 2006.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/nos-engagements/documents-esg': {
    title: 'Groupe iliad - ESG Publications',
    description: 'Declaration of extra-financial performance',
    image: '/free-iliad-icon.jpg'
  },
  '/en/carrieres/nos-valeurs': {
    title: 'iliad Group - Our values',
    description:
      'Our values - The Group’s people all share a distinctive mindset – the Free spirit. We wanted to try and define this mindset, so we decided to sound out our teams. An HR workshop was set up and it was unanimously agreed that the following four core values sum up who and what we are',
    image: '/free-iliad-icon.jpg'
  },
  '/en/carrieres/metiers': {
    title: 'iliad Group - Our jobs',
    description:
      'Our jobs - Telecoms technician, radio engineer, multimedia advisor, store manager and much more. Take a look at the video clips below to see the wide range of career opportunities we offer and see if you’d like to join our Free family!',
    image: '/free-iliad-icon.jpg'
  },
  '/en/carrieres/pourquoi-nous-rejoindre': {
    title: 'iliad Group - Why join us ?',
    description:
      'Why join us ? - As a growing Group, led by a strong entrepreneurial vision, our aim is to help our people grow too. Joining iliad is a guarantee of working on projects you’ll be proud of, while developing both your skills and responsibilities.',
    image: '/free-iliad-icon.jpg'
  },
  '/en/donnees-personnelles': {
    title: 'iliad Group - Personal data',
    description: 'Personal data - Privacy policy and personal data management',
    image: '/free-iliad-icon.jpg'
  },
  '/en/mentions-legales': {
    title: 'iliad Group - Legal notices',
    description: 'iliad Group Legal notices',
    image: '/free-iliad-icon.jpg'
  },
  '/en/arcep': {
    title: 'iliad Group - Arcep indicators',
    description: 'iliad Group Arcep indicator',
    image: '/free-iliad-icon.jpg'
  },
  '/en/documentation': {
    title: 'iliad Group - Documentation',
    description: 'iliad Group Documentation',
    image: '/free-iliad-icon.jpg'
  },
  '/en/contact': {
    title: 'iliad Group - Contact us',
    description: 'Contact us',
    image: '/free-iliad-icon.jpg'
  },
  '/en/actualites/article': {
    title: 'iliad Group - Articles',
    description: 'iliad Group Articles',
    image: '/free-iliad-icon.jpg'
  },
  '/en/actualites': {
    title: 'iliad Group - Newsroom',
    description: 'iliad Group Newsroom',
    image: '/free-iliad-icon.jpg'
  },
  default: {
    title: 'iliad Group',
    description: 'iliad Group',
    image: '/free-iliad-icon.jpg'
  }
}

export const metaData = (language) =>
  ({
    fr: META_FR,
    en: META_EN
  }[language])
